import { render, staticRenderFns } from "./xiaoshou.vue?vue&type=template&id=7d7f356c&scoped=true"
import script from "./xiaoshou.vue?vue&type=script&lang=js"
export * from "./xiaoshou.vue?vue&type=script&lang=js"
import style0 from "./xiaoshou.vue?vue&type=style&index=0&id=7d7f356c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7f356c",
  null
  
)

export default component.exports